import React from 'react';
import PostItem from '../post-item';

const CommentItem = React.memo(({comment, currentUserId, isAuthorized, getCommentRef, highlightId}) => {
    const isFollowing = comment?.author?.followingUser || false;
    return (
        <PostItem
            post={comment}
            userId={null}
            currentUserId={currentUserId}
            isAuthorized={isAuthorized}
            isFollowing={isFollowing}
            getPostRef={getCommentRef}
            highlightId={highlightId}
        />
    );
});

export default CommentItem;

